// Sales-target-api
export const salesCenterTargetListApi = 'sales-center/sales-target/list'
export const demandOrderListApi = 'sales-center/demand-order-entry/list'
export const demandOrderStoreApi = 'sales-center/demand-order-entry/store'
export const demandOrderUpdateApi = 'sales-center/demand-order-entry/update'
export const demandOrderById = 'sales-center/demand-order-entry/demand-order-data'

// get fiscal start and end date
export const fiscalYearData = 'master-fiscal-year/show'
// sales entry-api
export const scSalesListApi = '/sales-center/sales-entry/list'
export const salesEntryStoreApi = '/sales-center/sales-entry/store'
export const availableStockAndPriceApi = '/sales-center/sales-entry/stock-and-price'
// Delivery Order Receive Routes
export const deliveryOrderReceiveListApi = 'sales-center/delivery-order-receive/list'
export const deliveryOrderReceiveStoreApi = 'sales-center/delivery-order-receive/store'
export const deliveryOrderReceivedListApi = 'sales-center/delivery-order-receive/received-list'
export const deliveryReceiveDeleteApi = 'sales-center/delivery-order-receive/delete'

// Monthly Sales Report
export const salesReportApi = 'sales-center/sales-report/list'

// Stock Report
export const stockReportApi = 'sales-center/stock-report/list'

// Dashboard
export const dashboardApi = 'sales-center/dashboard/list'

// Return Product Routes
export const returnProductListApi = 'sales-center/delivery-order-return/list'
export const deliveryReturnStoreApi = 'sales-center/delivery-order-return/store'
